import { gql } from '@apollo/client';

export const activateBusinessPartner = gql`
  mutation activateBusinessPartner($entityId: String!) {
    salesforceManagement {
      entities {
        businessPartner {
          salesforceManagement {
            activateBusinessPartner(entityId: $entityId) {
              id
              views {
                SalesforceManagement_all {
                  properties {
                    Status
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const deactivateBusinessPartner = gql`
  mutation deactivateBusinessPartner($entityId: String!) {
    salesforceManagement {
      entities {
        businessPartner {
          salesforceManagement {
            deactivateBusinessPartner(entityId: $entityId) {
              id
              views {
                SalesforceManagement_all {
                  properties {
                    Status
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
